import { InternshipsTable } from "../_components/InternshipsTable";

export default function AlumniInternshipsPage() {
  return (
    <InternshipsTable
      isAlumni={true}
      heading="PGM Program Historical Alumni Internships"
      body="Search for or view all historical alumni internships associated with this PGM University Program"
      searchPlaceholder="Search Students"
      testId="alumni-table"
      showStatusFilter={false}
      showActionButtons={false}
    />
  );
}
